export const displayTime = (totalSeconds: number): string => {
	const roundedSeconds = Math.floor(totalSeconds)

	const hours = Math.floor(roundedSeconds / 3600)
	const minutes = Math.floor((roundedSeconds % 3600) / 60)
	const seconds = roundedSeconds % 60

	return [
		String(hours).padStart(2, '0'),
		String(minutes).padStart(2, '0'),
		String(seconds).padStart(2, '0')
	].join(':')
}
